<mat-card appearance="outlined" class="information-card">
  <div class="header row">
    <h2>Website Information</h2>
    <button matRipple class="button" [matMenuTriggerFor]="menu">
      <fa-icon [icon]="['fas', 'ellipsis-vertical']" size="lg"></fa-icon>
    </button>

    <mat-menu #menu="matMenu">
      @if (websiteData().website.status === 'ACTIVE') {
        <button mat-menu-item (click)="disableWebsite.emit()">
          <fa-icon [icon]="['fas', 'pause']" size="sm"></fa-icon>
          <span>Disable Website</span>
        </button>
      } @else {
        <button mat-menu-item (click)="enableWebsite.emit()">
          <fa-icon [icon]="['fas', 'play']" size="sm"></fa-icon>
          <span>Enable Website</span>
        </button>
      }
      @if (websiteData().website.type === 'MAIN') {
        <button mat-menu-item (click)="renameMain.emit()">
          <fa-icon [icon]="['fas', 'pen']" size="sm"></fa-icon>
          <span>Rename Main</span>
        </button>
      } @else {
        <button mat-menu-item class="red" (click)="deleteWebsite.emit()">
          <fa-icon [icon]="['fas', 'trash']" size="sm"></fa-icon>
          <span>Delete</span>
        </button>
      }
    </mat-menu>
  </div>
  <div class="info-row row">
    @for (info of websiteInfo; track $index) {
      <div class="info">
        <div class="label">{{ info.label }}</div>
        @let text = info.text(websiteData());
        @if (info.label === 'SSL Certificate' && isCertificate(text)) {
          <div class="text" [ngClass]="{ green: !!text, red: !text }">
            {{ CERTIFICATES_MAP[text] || 'None' }}
            <fa-icon [icon]="['fas', text ? 'check' : 'xmark']" size="sm"></fa-icon>
          </div>
        } @else if (info.label === 'CDN') {
          <app-status-label
            [status]="text ? STATUSES.ACTIVE : STATUSES.DISABLED"
          ></app-status-label>
        } @else if (info.label === 'Redis' && isStatus(text)) {
          <app-status-label [status]="text"></app-status-label>
        } @else {
          <div class="text">{{ text }}</div>
        }
      </div>
    }
  </div>
  <div class="buttons-row row">
    <button matButton="filled" (click)="manageWordpress.emit()">
      <fa-icon matPrefix [icon]="['fab', 'wordpress-simple']" size="lg"></fa-icon>
      Manage Wordpress
    </button>
    <button matButton="outlined" (click)="createStaging.emit()">
      <fa-icon matPrefix [icon]="['fas', 'object-ungroup']" size="sm"></fa-icon>
      Create Staging
    </button>
    <button matButton="outlined" (click)="addAlias.emit()">
      <fa-icon matPrefix [icon]="['fas', 'plus']" size="sm"></fa-icon>
      Add Alias
    </button>
    <button matButton="outlined" (click)="addSubdomain.emit()">
      <fa-icon matPrefix [icon]="['fas', 'plus']" size="sm"></fa-icon>
      Add Subdomain
    </button>
    <button matButton="outlined">
      <fa-icon matPrefix [icon]="['fas', 'arrow-right-arrow-left']" size="sm"></fa-icon>
      Migrate Site
    </button>
    <button matButton="outlined" (click)="showLogs.emit()">
      <fa-icon matPrefix [icon]="['fas', 'list']" size="sm"></fa-icon>
      Logs
    </button>
  </div>
</mat-card>
